import Vue from 'vue';
import VueRouter from 'vue-router';
import { socialMngRouter } from './socialMngRouter'; 
import { salaryRouter } from './salaryRouter'; 
import { holidayWelfareRouter } from './holidayWelfareRouter'; 
import { appCenterRouter } from './appCenterRouter'; 
import { commercialRouter } from './commercialRouter'; 
import { smartRouter } from './smartRouter'; 
import { systemRouter } from './systemRouter'; 
import { integralSystemRouter } from './integralSystemRouter'; 
import { employeeLearnRouter } from './employeeLearnRouter'; 
import { pointsMallRouter  } from './pointsMallRouter'; 
import { insuranceTrustRouter  } from './insuranceTrustRouter'; 
import { healthCheckupRouter  } from './healthCheckupRouter'; 
import { paySalaryRouter  } from './paySalaryRouter'; 
import { lgSettlementRouter  } from './lgSettlementRouter'; 
import { employeeRosterRouter  } from './employeeRosterRouter'; 
import { contractManagementRouter }from './contractManagementRouter';
import { supplierProductMngRouter } from './supplierProductMngRouter'; 
import { dataStatisticsRouter } from './dataStatisticsRouter'; 
import { userRouter } from './userRouter'; 
import { invoiceMngRouter } from './invoiceMngRouter'; 
import { thirdLinkRouter } from './thirdLinkRouter'; 
import { aiHelperRouter } from './aiHelperRouter'; 

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/ERSIndex'
  },
  {
    path: '/ERSIndex',
    name: 'ERSIndex',
    redirect: '/smartEntry',
    component: () => import(/* webpackChunkName: "about" */ '../views/ERSIndex.vue'),
    meta: {
      // requiresAuth: true
    },
    children: [
      ...socialMngRouter,
      ...userRouter,
      ...invoiceMngRouter,
      ...salaryRouter,
      ...supplierProductMngRouter,
      ...holidayWelfareRouter,
      ...lgSettlementRouter,
      ...healthCheckupRouter,
      ...paySalaryRouter,
      ...appCenterRouter,
      ...commercialRouter,
      ...smartRouter,
      ...systemRouter,
      ...integralSystemRouter,
      ...employeeLearnRouter,
      ...pointsMallRouter,
      ...insuranceTrustRouter,
      ...employeeRosterRouter,
      ...contractManagementRouter,
      ...dataStatisticsRouter,
      ...thirdLinkRouter,
      ...aiHelperRouter
    ]
  }
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
